import{b as L}from"./utils-BuG-uH50.js";const j=(a,{isSlide:e=!1}={})=>{var $,f,o,k,h,s,v,g;const{key:r,title:l,link:w,imageInfo:p,sellingPrice:i,listPrice:n,custom:d,ticket:y}=a,x=window.themeVars.localization.market!=="en-GB"?`/${window.themeVars.localization.market.toLowerCase()}`:"",C=((k=(o=(f=($=p==null?void 0:p.images)==null?void 0:$[0])==null?void 0:f.sources)==null?void 0:o[0])==null?void 0:k.url)||"",c=(i==null?void 0:i.min)||0,b=(n==null?void 0:n.min)>(i==null?void 0:i.min)?n.min:0,t=(s=(h=d==null?void 0:d.product_hover_image)==null?void 0:h[0])==null?void 0:s.label,_=(g=(v=d==null?void 0:d.colour_count)==null?void 0:v[0])==null?void 0:g.label;return`
    <${e?"li":"div"}
      class="product-card ${e?"splide__slide":""}"
      data-voyado-product
      data-product-key="${r}"
      data-product-ticket="${y}"
    >
      ${O(d,c,b)}
      ${P(a)}
      <a 
        href="${x}${w}"
        class="product-card__image-container ${t?"has-hover":""}"
      >
        <img 
          src="${C}" 
          alt="Image of ${l}"
          class="product-card__image-container--primary" 
        />
        ${t?`
          <img 
            src="${t}" 
            alt="Secondary image of ${l}" 
            class="product-card__image-container--secondary" 
          />
        `:""}
      </a>
      <div class="product-card__content">
        <p class="product-card__title f1-lc">${l}</p>
        ${M(c,b)}
      </div>
       <p
        data-product-id="${r}" 
        class="product-card__taggstar f2-lc"
      >
      </p>
      ${_&&_>1?`
        <p class="product-card__colour-count f2-lc">
          ${_} Colours
        </p>
      `:""}
    </${e?"li":"div"}>
  `},M=(a,e)=>{let r="",l="product-card__price--current";return e&&(r=`
      <span class="product-card__price--original f1-lc">
        ${L(e)}
      </span>
    `,l="product-card__price--discounted"),`
    <div class="product-card__price">
      ${r}
      <span class="${l} f1-lc">
        ${L(a)}
      </span>
    </div>`},O=(a,e,r)=>{var w,p,i,n,d,y,x,C,c,b,t,_,$,f,o,k,h,s,v,g,V,z,B,F,H,T,G,I;if(e&&r&&e<r)return`
      <p class="product-card__label product-label product-label--sale">
        ${Math.round((1-e/r)*100)}% OFF
      </p>
    `;let l="";return(p=(w=a==null?void 0:a.stock)==null?void 0:w[0])!=null&&p.label?l=(n=(i=a==null?void 0:a.stock)==null?void 0:i[0])==null?void 0:n.label:(y=(d=a==null?void 0:a.petite)==null?void 0:d[0])!=null&&y.label?l=(C=(x=a==null?void 0:a.petite)==null?void 0:x[0])==null?void 0:C.label:(b=(c=a==null?void 0:a.collection)==null?void 0:c[0])!=null&&b.label?l=(_=(t=a==null?void 0:a.collection)==null?void 0:t[0])==null?void 0:_.label:(f=($=a==null?void 0:a.new)==null?void 0:$[0])!=null&&f.label?l=(k=(o=a==null?void 0:a.new)==null?void 0:o[0])==null?void 0:k.label:(s=(h=a==null?void 0:a.back_in_stock)==null?void 0:h[0])!=null&&s.label?l=(g=(v=a==null?void 0:a.back_in_stock)==null?void 0:v[0])==null?void 0:g.label:(z=(V=a==null?void 0:a.available_to_rent)==null?void 0:V[0])!=null&&z.label?l=(F=(B=a==null?void 0:a.available_to_rent)==null?void 0:B[0])==null?void 0:F.label:(T=(H=a==null?void 0:a.nc_exclusive)==null?void 0:H[0])!=null&&T.label&&(l=(I=(G=a==null?void 0:a.nc_exclusive)==null?void 0:G[0])==null?void 0:I.label),l?`
      <p class="product-card__label product-label product-label--default">
        ${l}
      </p>
    `:""},P=a=>{var r;const e=((r=a.link)==null?void 0:r.replace("/products/",""))||"";return`
    <span
      class="product-card__wishlist"
      data-wishlist-button
      data-product-id="${a.key}"
      data-product-handle="${e}"
    >
      ${window.themeVars.icons.wishlist}
    </span>
  `};export{j as b};
